module.exports = __webpack_public_path__ + "img/feature-tile-icon-03.2388f986.svg";